module.exports = __webpack_public_path__ + "static/media/snare.f987b25d.wav";


//////////////////
// WEBPACK FOOTER
// ./node_modules/jazzband/demo/samples/drummer/snare.wav
// module id = 202
// module chunks = 0